import Alpine from 'alpinejs';

Alpine.data('arrow', () => ({
    init() {
        new Arrow(this.$root);
    },
}));

class Arrow {
    constructor(element) {
        this.element = element;
        this.hoverTarget = this.readCssPixelValue('--arrow-bounce-end', 10);
        this.pressTarget = this.readCssPixelValue('--arrow-press-end', 15);
        this.animationStart = this.readCssPixelValue('--arrow-bounce-start', -5);
        this.transitionDuration = 350;
        this.resumeAnimationTimeout = null;

        if (this.element.classList.contains('arrow--is-animated')) {
            this.registerAnimationInteractions();
        }

        window.addEventListener('click', (e) => {
            e.target.classList.contains('hero__arrow') ? this.scrollDown() : null;
        });
    }

    registerAnimationInteractions() {
        this.element.addEventListener('pointerenter', () => this.moveToHoverTarget());
        this.element.addEventListener('focusin', () => this.moveToHoverTarget());
        this.element.addEventListener('pointerleave', () => this.resumeBounce());
        this.element.addEventListener('focusout', () => this.resumeBounce());
        this.element.addEventListener('pointerdown', () => this.moveToPressTarget());
        this.element.addEventListener('pointerup', () => this.moveToHoverTarget());
        this.element.addEventListener('pointercancel', () => this.moveToHoverTarget());
    }

    moveToHoverTarget() {
        this.element.classList.remove('arrow--is-pressed');
        this.freezeAtCurrentPosition();
        this.moveTo(this.hoverTarget);
    }

    moveToPressTarget() {
        this.freezeAtCurrentPosition();
        this.element.classList.add('arrow--is-pressed');
        this.moveTo(this.pressTarget);
    }

    resumeBounce() {
        clearTimeout(this.resumeAnimationTimeout);
        this.element.classList.remove('arrow--is-pressed');
        this.freezeAtCurrentPosition();
        this.moveTo(this.animationStart);
        this.resumeAnimationTimeout = setTimeout(() => {
            this.element.classList.remove('arrow--is-interactive');
            this.element.style.transform = '';
        }, this.transitionDuration);
    }

    freezeAtCurrentPosition() {
        clearTimeout(this.resumeAnimationTimeout);
        let currentY = this.getCurrentTranslateY();

        this.element.classList.add('arrow--is-interactive');
        this.element.style.transition = 'none';
        this.element.style.transform = `translateY(${currentY}px)`;
        this.element.offsetHeight;
        this.element.style.transition = '';
    }

    moveTo(targetY) {
        this.element.style.transform = `translateY(${targetY}px)`;
    }

    getCurrentTranslateY() {
        let transform = getComputedStyle(this.element).transform;

        if (!transform || transform === 'none') return 0;

        let matrix = new DOMMatrixReadOnly(transform);

        return matrix.m42;
    }

    readCssPixelValue(name, fallback) {
        let value = getComputedStyle(this.element).getPropertyValue(name);
        let parsedValue = parseFloat(value);

        return Number.isNaN(parsedValue) ? fallback : parsedValue;
    }

    scrollDown() {
        let parentSection = this.element.closest('section');
        let nextSection = parentSection.nextElementSibling;

        if (!nextSection) return;

        let cssHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        let offset = parseFloat(cssHeaderHeight) * 16 || 0; // rems to pixels
        let visualSpacing = 18;

        window.scrollTo({
            top: nextSection.getBoundingClientRect().top + window.scrollY - offset - visualSpacing,
            behavior: 'smooth',
        });
    }
}
